import * as React from 'react';
import Box from '@mui/material/Box';
import ProjectCard from './ProjectCard';
import { Col, Row } from 'react-bootstrap';
import InvasionImage from '../../Images/Invasion_KeyArt.png';
import KeysImage from '../../Images/roomkey.png';
import Seasons from '../../Images/reccenter-storefront.png';
import AnimatedPreview from '../../Images/animated-preview-recroom.png';
import RoomInventory from '../../Images/roominventory.jpg';



function ProjectCarousel() {
    const projects = [
        {
            title: "RecRoom",
            subtitle: "Software Engineer",
            description: "Rec Room is a free-to-play social app, which cross plays on everything from phones to VR headsets. Players can dress up, meet up and play in a variety of different rooms, and even build their own experiences and avatar items. It's a world where everyone can create!",
            team: "Economy and Avatars Team",
            tools: "Unity, C#",
            duration: "Sept. 2021 - March 2025",
            storyhook: "RecRoom was my first job after graduation, and I was hired as a Software Engineer on the Economy and Avatars Team. I was responsible for creating and maintaining the systems that allowed players to purchase and customize their avatars, as well as the systems that allowed creators to sell their own avatar items.",
            imagePath: require('../../Images/recroom.jpg'),
            altText: "RecRoom Logo and Avatars",
            internalProjects: [

                {
                    title: "Store UI and Purchase Flow Improvements",
                    summary: "I worked on a myriad of different projects related to the store during my time at RecRoom. Notably, I refactored the store's gifting flows for future ease of use, and implemented a new feature that allowed players to preview avatar items on an animated imposter rendered in the Item Details UI. Throughout my time at RecRoom, I was updating UI to our latest design standards, and refactoring what I could to make the codebase more maintainable.",
                    imageUrl: AnimatedPreview,
                    altText: "An image of RecRoom's Watch Store"
                },

                {
                    title: "Economy Tools for UGC Creators - Keys, Currencies and Consumables",
                    summary: "I contributed a number of projects toward improving the economy tools available to UGC creators. I implemented a feature which allowed Creators to dynamically scale Storefronts in their rooms, allowing them to determine how many items they could display at once. I also helped bring the ability for Creators to sell custom avatar items in their rooms, which was a critical step in expanding the UGC marketplace in RecRoom.",
                    imageUrl: KeysImage,
                    altText: "CV2 for In Game Economy"
                },
                {
                    title: "Rooms 2.0 Economy System - Room Inventory",
                    summary: "I created new CV2 chips to allow Creators to prompt players to purchase an item in their Room, adding another monetization tool for Creators. After working on a variety of tools for Creators in their rooms, I worked with the team to bring a new, extra-flexible economy toolset for the next generation of UGC rooms - Room Inventory.",
                    imageUrl: RoomInventory,
                    altText: "CV2 for In Game Economy",
                    externalLink: "https://rec.net/creator/p/rooms-2.0-inventory-offers",
                    linkText: "Rooms 2.0 Inventory and Offers Blog Post"
                },
                {
                    title: "Invasion - Limited Time Event System",
                    summary: "I contributed toward building RecRoom's Limited Time Event system by implementing tutorial UI to introduce players to the new feature. I also implemented UI for the event's main menu page, where players could see their current progess in the event, as well as the rewards they could earn.",
                    imageUrl: InvasionImage,
                    altText: "Invasion Logo and Avatars",
                    externalLink: "https://recroom.com/invasion",
                    linkText: "Event Blog Post"
                },
                {
                    title: "RR+ Exclusive Seasonal Items",
                    summary: "This was one of my first solo programming projects at RecRoom. I redesigned the RecCenter Storefront cards with a new style, and then implemented a feature that displayed which exclusive seasonal items are being given to RR+ subscribers that season.",
                    imageUrl: Seasons,
                    altText: "Image of the RecCenter Storefront, with the Seasonal Item Display",
                    externalLink: "https://store.steampowered.com/news/app/471710/view/3097916025913146053?l=english",
                    linkText: "RR+ Seasonal Items Patch Notes"
                },

            ]
        },
        {
            title: "Cooking Mama with 1st Playable Productions",
            subtitle: "Gameplay Programming Intern",
            description: "A cooking simulation-style minigame suite with a social media spin. The sixth installment in the Cooking Mama game series, this game seeks to recreate the motion controls of the Nintendo Wii using modern platform motion controls.",
            team: "Engineering Team",
            tools: "Unity, C#, Bugzilla, Slack, Audacity, Google Sheets",
            duration: "May 2019 - August 2019",
            imagePath: require('../../Images/XAL03100147019-20200405-1598_title-757063-299f.jpg'),
            altText: "Cooking Mama Cookstar img",
            storyhook: "Cooking Mama: Cookstar was the first console title I got to work on. I was a part of a small programming team, and a rather small company overall. As an intern, I was responsible for implementing new minigames and features. However, I quickly became the go-to person for all things game audio, and I was responsible for implementing all of the game's sound effects and music.",
            internalProjects: [
                {
                    title: "Audio Implementation",
                    summary: "Prior to my internship with 1st Playable, I would not have called myself qualified to handle any kind of game audio. However, within my first week, I was responsible for implementing the audio into the game. By the end of the summer, I had all of the game's audio files were sorted and summarized in a spreadsheet, contributed to the game's sound design document with detailed notes for key variables and timings, and implemented nearly all of the game's audio in Unity. I even recorded new sound effects of my own, using foley techniques I researched on my own.",
                },
                {
                    title: "Minigame Implementation",
                    summary: "In addition to my audio responsibilities, I was also responsible for implementing new minigames and features. It's near impossible for me to remember how many or which minigames worked on, but some examples of games include: a minigame where the player must catch falling ingredients in a pot, a minigame where the player tilts the controllers in order to cover a pan in butter, and a minigame where the player must shake the controller to mix ingredients together.",

                },
                {
                    title: "Quality Assurance Contributions",
                    summary: "I volunteered to help write the first draft of the game's test plan. We also performed a lot of our own manual tests, and for cataloguing bugs we found. Of course, we also fixed them ;)",
                    externalLink: "https://www.mobygames.com/game/144107/cooking-mama-cookstar/credits/switch/?autoplatform=true",
                    linkText: "Game Credits"
                },
            ]
        },
        {
            title: "Cyberdrive 2077 with MassDiGI",
            subtitle: "Gameplay Programming Intern, Quality Assurance Lead",
            description: "An intense fast-paced, action-packed and arcade-style endless runner. Race a car through a neon digital landscape at breakneck speeds and drive through endless obstacles that block your path. The iOS version is available on the App Store.",
            team: "Cyberdrive Team",
            tools: "Unity, C#",
            duration: "May 2018 - August 2018",
            imagePath: require('../../Images/cyberdrive2.jpg'),
            altText: "Cyberdrive Event Promo img",
            storyhook: "Cyberdrive 2077 was my first internship in the game industry. As a part of the MassDiGI program, I was a part of a team of five talented students, with whom I went through the entire game development pipeline - from idea to post-launch.",
            internalProjects: [
                {
                    title: "Quality Assurance Lead",
                    summary: "I took charge of handling all of our quality assurance needs for the summer. Between programming tasks, I was responsible for running playtests, and for cataloguing and fixing bugs. I developed my own organizational systems for tracking bugs on different spec mobile devices, and gathered feedback from playtesters, working with our designers and artists to implement changes.", 
                    imageUrl: '../../Images/Invasion_KeyArt.png',
                    altText: "Invasion Logo and Avatars"
                },
                {
                    title: "Organizing 'Switch Week'",
                    summary: "As a side task, I was responsible for organizing the program's 'Switch Week' event. During this event, all of the teams in the program would switch projects for a week, and I made sure that all of the teams had the documentation they needed to work on their new projects. I helped facilitate communication between the teams, and helped to ensure that the event ran smoothly.", 
                    imageUrl: '../../Images/Invasion_KeyArt.png',
                    altText: "Invasion Logo and Avatars"
                },
                {
                    title: "Playtests and Feedback",
                    summary: "On this project, I got a lot of experience running playtests, and gathering feedback from players. I learned how to ask the right questions to get the most useful feedback, and how to use that feedback to make meaningful changes to the game. Almost more importantly, I learned how not to ask questions. I learned how to observe players and gather feedback without leading them to the answers I wanted to hear. I also learned to iterate quickly, get feedback from MVPs, and let go of ideas are not working.", 
                    imageUrl: '../../Images/Invasion_KeyArt.png',
                    altText: "Invasion Logo and Avatars",
                    externalLink: "https://www.youtube.com/watch?v=qSY4NfVGKxg",
                    linkText: "Gameplay Video"
                },
            ]
        },
        {
            title: "VRm Medical Arm Model",
            subtitle: "Environment Designer, Audio Engineer",
            description: "Virtual Reality simulation game designed for medical students to examine, learn, and play with an anatomically correct human arm.",
            imagePath: require('../../Images/arm.PNG'),
            altText: "VRm Medical Arm Model",
            team: "RIT Research Studio Team",
            tools: "Unity, C#, Audacity",
            duration: "Spring 2018",
            storyhook:"This project was done with a research team at RIT, and was designed to be a tool for medical students to learn about the anatomy of the human arm in virtual reality. I was responsible for designing the environment, and for implementing environmental audio.",
            internalProjects: [

            ]
        },
        {
            title: "Steampunk Rochester",
            subtitle: "Game Writer, Gameplay Programmer",
            description: "Mobile Augmented Reality location-based game with a heavy focus on story. Prototyped in Unity with Mapbox and Vuforia, as well as with ARIS and Esri StoryMaps.",
            imagePath: require('../../Images/map.PNG'),
            altText: "Map of Historical Rochester - App UI",
            team: "RIT Research Studio Team",
            tools: "Unity, C#, MapBox, Vuforia, ARIS, Esri StoryMaps",
            duration: "Fall 2018",
            storyhook:"Another research project done at RIT, Steampunk Rochester was a location-based game designed to teach players about the history of Rochester, NY. We conducted research on different map and AR technologies, and prototyped the game in Unity with Mapbox and Vuforia. As players walked around the city, they could scan points of interest and play a visual-novel type game to immerse themselves in the history of the area. I wrote several different character storylines.",
            internalProjects: [
            ]
        },
        {
            title: "Descendate",
            subtitle: "Project Manager, Gameplay Engineering",
            description: "Dungeon Crawler Dating Simulator designed for PC play. Built in Unity using C# and Fungus plug-in. Long term team project discontinued in 2020.",
            imagePath: require('../../Images/ahh.png'),
            altText: "Descendate Game Logo",
            storyhook: "A personal project with my roommates - Descendate was a dungeon crawler dating simulator. Players split their time between adventuring through a dungeon underground, and trying to woo their townsfolk of choice above ground. Inspired by Stardew valley, I implemented a day/night cycle and NPC routines with pathing around the city. The project was discontinued in 2020, but we had a lot of fun working on it.",
            team: "Descendate Team",
            tools: "Unity, C#, Fungus",
            duration: "Fall 2019 - Spring 2020",
            internalProjects: [
            ]
            
        }];
    
    return (
        <Box className="bg-dark text-white p-5" sx={{ flexGrow: 1 }} >
            <hr></hr>
            <h2 className='p-3'>Professional Projects</h2>
            <div className="pb-5" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Row>
                    <Col xs={12} md={4} lg={4} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ProjectCard
                            imagePath={projects[0].imagePath}
                            altText={projects[0].altText}
                            title={projects[0].title}
                            subtitle={projects[0].subtitle}
                            description={projects[0].description}
                            team={projects[0].team}
                            tools={projects[0].tools}
                            duration={projects[0].duration}
                            storyhook={projects[0].storyhook}
                            internalProjects={projects[0].internalProjects}
                        ></ProjectCard>
                    </Col>
                    <Col  xs={12} md={4} lg={4} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ProjectCard
                            imagePath={projects[1].imagePath}
                            altText={projects[1].altText}
                            title={projects[1].title}
                            subtitle={projects[1].subtitle}
                            description={projects[1].description}
                            team={projects[1].team}
                            tools={projects[1].tools}
                            duration={projects[1].duration}
                            storyhook={projects[1].storyhook}
                            internalProjects={projects[1].internalProjects}
                        ></ProjectCard>
                    </Col>
                    <Col  xs={12} md={4} lg={4} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ProjectCard
                            imagePath={projects[2].imagePath}
                            altText={projects[2].altText}
                            title={projects[2].title}
                            subtitle={projects[2].subtitle}
                            description={projects[2].description}
                            team={projects[2].team}
                            tools={projects[2].tools}
                            duration={projects[2].duration}
                            storyhook={projects[2].storyhook}
                            internalProjects={projects[2].internalProjects}
                            
                        ></ProjectCard>
                    </Col>
                </Row>
            </div>
            <hr></hr>
            <h2 className='p-3'>Personal + Research Projects</h2>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Row>
                    <Col xs={12} md={4} lg={4} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ProjectCard
                            imagePath={projects[3].imagePath}
                            altText={projects[3].altText}
                            title={projects[3].title}
                            subtitle={projects[3].subtitle}
                            description={projects[3].description}
                            team={projects[3].team}
                            tools={projects[3].tools}
                            duration={projects[3].duration}
                            storyhook={projects[3].storyhook}
                            internalProjects={projects[3].internalProjects}

                        ></ProjectCard>
                    </Col>
                    <Col  xs={12} md={4} lg={4} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ProjectCard
                            imagePath={projects[4].imagePath}
                            altText={projects[4].altText}
                            title={projects[4].title}
                            subtitle={projects[4].subtitle}
                            description={projects[4].description}
                            team={projects[4].team}
                            tools={projects[4].tools}
                            duration={projects[4].duration}
                            storyhook={projects[4].storyhook}
                            internalProjects={projects[4].internalProjects}

                        ></ProjectCard>
                    </Col>
                    <Col  xs={12} md={4} lg={4} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ProjectCard
                            imagePath={projects[5].imagePath}
                            altText={projects[5].altText}
                            title={projects[5].title}
                            subtitle={projects[5].subtitle}
                            description={projects[5].description}
                            team={projects[5].team}
                            tools={projects[5].tools}
                            duration={projects[5].duration}
                            storyhook={projects[5].storyhook}
                            internalProjects={projects[5].internalProjects}
                        ></ProjectCard>
                    </Col>
                </Row>
            </div>
        </Box>
  );
}

export default ProjectCarousel;